module.exports = __webpack_public_path__ + "img/labour.68c51fc0.svg";